import Repository from './repository'

const resource = '/students'

export default {
  AlunoGetById (id) {
    return Repository.get(`${resource}/${id}`)
  },
  AlunoGetCurrent (id) {
    return Repository.get(`${resource}/current`)
  },
  AlunoBloqueadoGet (id) {
    return Repository.get(`${resource}/block`)
  },
  AlunoGet () {
    return Repository.get(`${resource}`)
  },
  AlunoGetInativos () {
    return Repository.get(`${resource}/inactive-students`)
  },
  AlunoPost (item) {
    return Repository.post(`${resource}`, item)
  },
  AlunoPut (id, item) {
    return Repository.put(`${resource}/${id}`, item)
  },
  AlunoDelete (planoId) {
    return Repository.delete(`${resource}/${planoId}`)
  },
  AlunoRestore(id) {
    return Repository.put(`${resource}/${id}/restore`)
  },
  AlunoForceDelete(id) {
    return Repository.delete(`${resource}/${id}/force-delete`)
  },
  // Bloqueio manual
  manualBlock(id) {
    return Repository.post(`${resource}/${id}/manual-block`)
  },
  manualUnblock(id) {
    return Repository.post(`${resource}/${id}/manual-unblock`)
  },
}
